import type { FeedTab } from '../store/useAppStore';
import { useAppStore } from '../store/useAppStore';
import { haptic } from '../utils/haptic';

const TABS: { key: FeedTab; label: string }[] = [
  { key: 'my', label: 'Мои' },
  { key: 'public', label: 'Витрина' },
  { key: 'requests', label: 'Заявки' },
];

export function FeedTabs() {
  const activeTab = useAppStore((s) => s.activeTab);
  const setActiveTab = useAppStore((s) => s.setActiveTab);

  return (
    <nav className="feed-tabs" aria-label="Разделы">
      {TABS.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={`feed-tabs__tab ${activeTab === key ? 'feed-tabs__tab--active' : ''}`}
          onClick={() => { haptic.select(); setActiveTab(key); }}
        >
          {label}
        </button>
      ))}
    </nav>
  );
}
